import { useRef } from 'react'
import { useL7Map } from '../../hooks/useL7Map'
import { useTrackLayers } from '../../hooks/useTrackLayers'
import { TRACK_COLOR_ACTIVE, TRACK_COLOR_DONE, type TrackTask } from '../../lib/track'

/** 救援流向内嵌小地图：志愿者任务轨迹折线（时间渐变 + 方向箭头），带语义色图例 */
export function TrackMap({ tasks }: { tasks: TrackTask[] }) {
  const containerRef = useRef<HTMLDivElement>(null)
  const { scene, ready } = useL7Map(containerRef)
  useTrackLayers(scene, ready, tasks, { zIndex: 6, fitBounds: true })

  return (
    <div className="relative h-[280px] overflow-hidden rounded-lg border border-border/60">
      <div ref={containerRef} className="absolute inset-0" role="application" aria-label="志愿者轨迹地图" />
      <div className="panel-glass pointer-events-none absolute bottom-2.5 left-2.5 z-10 flex items-center gap-3 rounded-md px-2.5 py-1.5 text-[10px] text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <span className="size-2 rounded-full" style={{ background: TRACK_COLOR_ACTIVE }} /> 进行中
        </span>
        <span className="flex items-center gap-1.5">
          <span className="size-2 rounded-full" style={{ background: TRACK_COLOR_DONE }} /> 已完成
        </span>
      </div>
    </div>
  )
}
